const OVERLAY_ID = "saving-overlay";

export function showDialogOverlay(dialogEl, text = "Kaydediliyor...") {
    hideDialogOverlay();

    const rect = dialogEl.getBoundingClientRect();
    const el = document.createElement("div");
    el.id = OVERLAY_ID;
    el.innerHTML = `
        <div class="saving-overlay-spinner"></div>
        <span class="saving-overlay-text">${text}</span>
    `;
    Object.assign(el.style, {
        position: "fixed",
        top: rect.top + "px",
        left: rect.left + "px",
        width: rect.width + "px",
        height: rect.height + "px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        background: "rgba(255,255,255,0.88)",
        backdropFilter: "blur(2px)",
        borderRadius: "12px",
        zIndex: "99999",
    });

    // dialog'a append et — top layer içinde render edilir, her şeyin üstünde
    dialogEl.appendChild(el);
}

export function hideDialogOverlay() {
    document.getElementById(OVERLAY_ID)?.remove();
}
